import React, {useState, useEffect} from 'react';
import { useParams } from 'react-router-dom'
import DomainTable  from '../../components/domainTable.js'

import {TechnologyChangesPageResult} from '../../../../server/routes/technology.js'

interface TechnologyChangesProps {
	server: string;
	pageData: unknown;
}

export default function TechnologyChanges({server, pageData}: TechnologyChangesProps) {

	const typedPageData = pageData as TechnologyChangesPageResult;
	let [data, setData] = useState(typedPageData);

	return (
		<>
            <section className="section section-sm">
                <div className="container">
                    <div className="row row-50">
                        <div className="col-md-12 col-lg-12 col-xl-12">
                        {
                            data.TechnologyAdded &&
                            <DomainTable domainList={data.TechnologyAdded}/>
                        }
                        {
                            data.TechnologyDropped &&
                            <DomainTable domainList={data.TechnologyDropped}/>
                        }
                        {
                            data.TechnologyChangedVersions &&
                            <DomainTable domainList={data.TechnologyChangedVersions}/>
                        }
                        </div>
                    </div>       
                </div> 
            </section>
		</>
	)
};
